import { render, staticRenderFns } from "./SelectUserDefinedGroup.vue?vue&type=template&id=1519d7d8"
import script from "./SelectUserDefinedGroup.vue?vue&type=script&lang=js"
export * from "./SelectUserDefinedGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports